module.exports = __webpack_public_path__ + "static/heart-logo-f632fa2f215bf120d8368e1f871a25b0.png";